import React from 'react';

import CN from './UiPage.module.scss'; // Since this is experiment, we can share the same .module.scss file

const ColorItem = ({ hex, variableName, index }) => (
  <div data-bem="ColorItem" className={CN.color} data-index={index}>
    <div className={CN.picker} style={{ backgroundColor: hex }}>
      {index}
    </div>
    <span className={CN.hex}>{hex}</span>
    <span className={CN.variableName}>{variableName}</span>
  </div>
);

// noinspection JSUnusedGlobalSymbols
export default ColorItem;
